<template>
  <div class="edit-member">
    <ValidationObserver ref="observer">
      <admin-layout v-if="!isLoading" title="Edit member">
        <form v-on:submit.prevent="editMember" class="signin">
          <ValidationProvider
            ref="email"
            rules="required"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field
              :error="errors && errors[0]"
              label="First name"
              name="first_name"
            >
              <bg-input
                :error="errors && errors[0]"
                name="first_name"
                :valid="changed && valid"
                v-model="user.first_name"
              />
            </bg-field>
          </ValidationProvider>
          <ValidationProvider
            ref="email"
            rules="required"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field
              :error="errors && errors[0]"
              label="Last name"
              name="last_name"
            >
              <bg-input
                :error="errors && errors[0]"
                name="last_name"
                :valid="changed && valid"
                v-model="user.last_name"
              />
            </bg-field>
          </ValidationProvider>
          <ValidationProvider
            ref="email"
            rules="required|email"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field :error="errors && errors[0]" label="Email" name="email">
              <bg-input
                :error="errors && errors[0]"
                name="email"
                :valid="changed && valid"
                v-model="user.email"
                :disabled="true"
              />
            </bg-field>
          </ValidationProvider>
          <bg-field label="Role" name="email">
            <bg-select
              :options="options"
              :value="user.role"
              @change="onRoleChange"
            ></bg-select>
          </bg-field>
          <bg-button text="Save" type="submit" :isLoading="isPosting" />
        </form>
      </admin-layout>
    </ValidationObserver>
  </div>
</template>

<style scoped>
.account {
  display: flex;
  justify-content: space-between;
}
.display {
  display: none;
}
</style>

<script>
import AdminLayout from "@/layouts/admin";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgButton from "@/components/bg-button";
import BgSelect from "@/components/bg-select";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "account",
  components: {
    BgButton,
    AdminLayout,
    BgField,
    BgInput,
    BgSelect,
  },
  data() {
    return {
      isPosting: false,
      isLoading: true,
      user: {
        first_name: "",
        last_name: "",
        email: "",
        company_id: "",
        role: { label: "Member", value: "company_member" },
      },
      options: [
        { label: "Admin", value: "company_admin" },
        { label: "Member", value: "company_member" },
      ],
    };
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
  },
  watch: {
    user: function (value) {
      this.user = value;
    },
  },
  async mounted() {
    const data = await API.user.getUser(this.$route.params.id);
    this.user = {
      ...this.user,
      first_name: data.profile.first_name,
      last_name: data.profile.last_name,
      email: data.email,
      role: this.options.find((i) => i.value === data.role),
    };
    this.isLoading = false;
  },
  methods: {
    onRoleChange(newRole) {
      this.user.role = newRole;
    },
    async editMember() {
      const res = await this.$refs.observer.validate();
      if (res) {
        this.isPosting = true;
        const payload = {
          email: this.user.email,
          role: this.user.role.value,
          profile: {
            first_name: this.user.first_name,
            last_name: this.user.last_name,
          },
        };
        const data = await API.user.updateUser(this.$route.params.id, payload);
        this.$router.push("/members");
      }
    },
  },
};
</script>
